import { CandleWorkerApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';
import { createQuery } from 'utils/queries';

import { Axios } from '../../axios';

import { normalizeCandleWorkers } from './normalizers';
import { CandleWorker, CandleWorkerInitializePayload, CandleWorkerQuery } from './types';

export class VoladeumCandleWorkers extends Axios {
  async list(query: CandleWorkerQuery): Promise<VoladeumResponse<CandleWorker[]>> {
    const res = await this.get<VoladeumResponse<CandleWorkerApi[]>>(
      `/v1/candle-workers${createQuery(query)}`
    );
    return {
      success: res.success,
      error: res.error,
      data: normalizeCandleWorkers(res.data),
    };
  }
  async initialize(
    pair_id: number,
    unix: number,
    payload: CandleWorkerInitializePayload
  ): Promise<VoladeumResponse<string>> {
    const res = await this.post<VoladeumResponse<string>>(
      `/v1/pairs/${pair_id}/candle-workers/${unix}/initialize`,
      payload
    );
    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }
}
